import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../actions'
import { Link } from 'react-router'
import PageHeader from './page-header'

const styles = {
  btnLayout: {
    marginRight:'10px',
    minWidth:'150px'
  }
}

let ConfirmEmail = ({ email, confirmed, redirectUriAfterLogin }) => (
  <div>
    <PageHeader title={"Please Confirm Email"}/>
    <div className='container'>
      <p>Is your email address <strong><em>{ email }</em></strong> still valid?</p>
      <button onClick={() => confirmed(redirectUriAfterLogin)} className='btn btn-success' style={styles.btnLayout}>Yes</button>
      <Link to={'/emails'} className='btn btn-danger' style={styles.btnLayout}>No</Link>
    </div>
  </div>
)

function mapStateToProps(state, ownProps) {
  const {redirectUriAfterLogin} = state
  return {
    email: state.user.user.email,
    redirectUriAfterLogin
  }
}

function mapDispatchToProps(dispatch) {
return ({
  confirmed: bindActionCreators(actions.primaryEmailConfirmed, dispatch),
})
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail)



// WEBPACK FOOTER //
// ./src/app/components/confirm-email.js